import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import { SweetAlertShow, LoadingDiv } from "../master/Master";
import { useNavigate } from "react-router-dom";
import { batchDetailsWithStudents, batchList } from "../../api/Batch";
import {
  librariesList,
  librarySeatsList,
  libraryShiftsList,
  libraryStudentAdd,
  libraryVacantSeatsList,
} from "../../api/Library";
import Header from "../master/SideBar";
import LibraryLayout from "./LibraryLayout";

export default function LibraryStudentAdd() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [libraries, setLibraries] = useState([]);
  const [seats, setSeats] = useState([]);
  const [shifts, setShifts] = useState([]);
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [studentData, setStudentData] = useState({});

  const [data, setData] = useState({});

  const getLibraryList = async () => {
    setLoading(true);
    let addUrl = `status=1`;
    try {
      const response = await librariesList(addUrl);
      if (response.data?.status) {
        setLibraries(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };
  const getLibraryShiftList = async () => {
    setLoading(true);
    let addUrl = `status=1`;
    try {
      const response = await libraryShiftsList(addUrl);
      if (response.data?.status) {
        setShifts(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getLibrarySeats = async () => {
    if (!data?.library_id || !data?.shift_id) return;
    setLoading(true);
    let addUrl = `&library_id=${data?.library_id}&shift_id=${data?.shift_id}`;
    try {
      const response = await libraryVacantSeatsList(addUrl);
      if (response.data?.status) {
        setSeats(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchesList = async () => {
    setLoading(true);
    try {
      const response = await batchList();
      if (response.data?.status) {
        setBatches(response?.data?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const getBatchStudents = async (id) => {
    setLoading(true);
    try {
      let addUrl = `id=${id}`;
      const response = await batchDetailsWithStudents(addUrl);
      if (response.data?.status) {
        setStudents(response?.data?.data?.active_batch_students);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLibraryList();
    getBatchesList();
    getLibraryShiftList();
  }, []);
  useEffect(() => {
    getLibrarySeats();
  }, [data?.library_id, data?.shift_id]);

  const createLibraryStudent = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await libraryStudentAdd(formData);
      if (response?.data?.status) {
        navigate("/library/students");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <LibraryLayout />
                  <div className="col-12">
                    <div className="card my-3">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2">
                          <h4 className="text-primary mb-0">Students</h4>
                        </div>
                        <form onSubmit={createLibraryStudent}>
                          <div className="row g-3 p-3">
                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline ">
                                <select
                                  className="form-select"
                                  id="batch_id"
                                  name="batch_id"
                                  value={data?.batch_id}
                                  onChange={(e) => {
                                    getBatchStudents(e.target.value);
                                    setData({
                                      ...data,
                                      batch_id: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select Batch</option>
                                  {batches?.map((batch) => (
                                    <option key={batch?.id} value={batch?.id}>
                                      {batch?.title} ({batch?.course?.title})
                                    </option>
                                  ))}
                                </select>
                                <label for="batch_id">Select Batch</label>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-floating form-floating-outline">
                                <select
                                  className="form-select"
                                  name="student_id"
                                  value={data?.student_id}
                                  onChange={(e) => {
                                    setStudentData(
                                      students?.find(
                                        (s) =>
                                          Number(s.student_id) ===
                                          Number(e.target.value),
                                      )?.student_info || "",
                                    );
                                    setData({
                                      ...data,
                                      student_id: e.target.value,
                                    });
                                  }}
                                >
                                  <option value="">Select Student</option>
                                  {students.map((student) => (
                                    <option
                                      key={student.id}
                                      value={student?.student_info.id}
                                    >
                                      {student?.student_info?.name} (
                                      {student?.student_info?.registration_no})
                                    </option>
                                  ))}
                                </select>

                                <label>Select Student</label>
                              </div>
                            </div>
                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control input-capitalize"
                                placeholder="Enter Student Id"
                                name="student_name"
                                required
                                defaultValue={studentData?.name}
                              />
                              <label className="">Student Name</label>
                            </div>
                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Student Registration No"
                                name="registration_no"
                                defaultValue={studentData?.registration_no}
                              />
                              <label className="">Registration No</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control input-uppercase"
                                placeholder="Enter Father Name"
                                name="father_name"
                                defaultValue={studentData?.father_name}
                              />
                              <label className="">Father Name</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Mobile"
                                name="mobile"
                                required
                                defaultValue={studentData?.phone}
                              />
                              <label className="">Mobile </label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <textarea
                                className="form-control input-uppercase"
                                rows="2"
                                placeholder="Enter Hostel Address"
                                name="address"
                                defaultValue={
                                  studentData?.village &&
                                  `${studentData?.village ?? ""}, ${
                                    studentData?.district ?? ""
                                  } ${studentData?.state ?? ""} ${
                                    studentData?.zipcode ?? ""
                                  }`
                                }
                              ></textarea>
                              <label className="">Address</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                type="Date"
                                className="form-control"
                                placeholder="Enter joining Date"
                                name="joining_date"
                                required
                                defaultValue={studentData?.admission_date}
                              />
                              <label className="">Joining Date</label>
                            </div>
                            <hr />

                            <div className="col-md-6 form-floating form-floating-outline mb-4">
                              <select
                                name="library_id"
                                className="form-control"
                                required
                                value={data?.library_id}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    library_id: e.target.value,
                                  });
                                }}
                              >
                                <option selected disabled value="">
                                  Select Library
                                </option>
                                {libraries?.map((library, i) => (
                                  <option value={library?.id}>
                                    {library?.name}
                                  </option>
                                ))}
                              </select>
                              <label>Select Library</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline mb-4">
                              <select
                                name="shift_id"
                                className="form-control"
                                required
                                value={data?.shift_id}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    shift_id: e.target.value,
                                  });
                                }}
                              >
                                <option selected disabled value="">
                                  Select Library Shift
                                </option>
                                {shifts?.map((shift, i) => (
                                  <option value={shift?.id}>
                                    {shift?.name}
                                  </option>
                                ))}
                              </select>
                              <label>Select Library Shift</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline mb-4">
                              <select
                                name="seat_id"
                                className="form-control"
                                required
                              >
                                <option selected disabled value="">
                                  Select Seat
                                </option>

                                {seats?.map((seat) => (
                                  <option key={seat?.id} value={seat?.id}>
                                    {seat?.seat_no}
                                  </option>
                                ))}
                              </select>
                              <label>Seat No</label>
                            </div>
                            <div className="col-md-6 form-floating form-floating-outline mb-4">
                              <select
                                name="fee_type"
                                className="form-control"
                                required
                              >
                                <option selected disabled value="">
                                  Select Fee Type
                                </option>
                                <option value="Monthly">Monthly</option>
                                <option value="Full">Full</option>
                              </select>
                              <label> Fee Type</label>
                            </div>

                            <div className="col-md-6 form-floating form-floating-outline">
                              <input
                                className="form-control"
                                type="number"
                                placeholder="seat_charge"
                                name="final_fee"
                                defaultValue={
                                  libraries?.find(
                                    (library) => library.id == data?.library_id,
                                  )?.seat_charge
                                }
                                required
                              />
                              <label>Bed Charge</label>
                            </div>

                            <div className="d-flex justify-content-end">
                              <button
                                type="submit"
                                className="btn btn-primary px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <span
                                    className="spinner-border spinner-border-sm me-2"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                ) : (
                                  "Submit"
                                )}
                                {loading ? " Submitting..." : ""}
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
